import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

class FormBanco08  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            fechaDesde: null,
            fechaHasta: null,
        };
        
        this.limpiar = this.limpiar.bind(this);
        this.imprimirMvtosEfectivoPendDeposito = this.imprimirMvtosEfectivoPendDeposito.bind(this);
    }
    
    componentDidMount(){        
        this.props.generar_LogAuditoriaIngresoForm('0708');
        let fechaProceso = getFechaProcesoPorModulo('07');
        this.setState({ fechaDesde: moment(fechaProceso, "DD/MM/YYYY"),
                        fechaHasta: moment(fechaProceso, "DD/MM/YYYY")});
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0708');
    }

  
    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('07');
        this.setState({ fechaDesde: moment(fechaProceso, "DD/MM/YYYY"),
                        fechaHasta: moment(fechaProceso, "DD/MM/YYYY")});
    }

    imprimirMvtosEfectivoPendDeposito(){
        let fechaDesde;
        let fechaHasta;

        if(!validarFechaMomentEnFormatoString(formatearFechaMoment_a_String(this.state.fechaDesde))){
            alert('La fecha Desde es inválida.');
            return;
        }
        
        if(!validarFechaMomentEnFormatoString(formatearFechaMoment_a_String(this.state.fechaHasta))){
            alert('La fecha Hasta es inválida.');
            return;
        }

        if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){
            alert('La fecha Desde no puede ser mayor que la fecha Hasta.');
            return;
        }
        
        fechaDesde = formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde);
        fechaHasta = formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta);

        let parametrosRpt = '&rpt=38&param1=' + fechaDesde + '&param2=' + fechaHasta;
        visualizarReporteEnPdf(parametrosRpt);
    }

    render(){
        return (
            <ContenedorForm porc_ancho={60}>
            <HeaderForm>
                <TituloForm>Movimientos Depósito/Efectivo pendientes de depositar</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-sm-1' margen_arriba='30'>
                            <LabelForm>Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-3' margen_arriba='30'>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fechaEscogida)=>{this.setState({fechaDesde: fechaEscogida});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-1' margen_arriba='30'>
                            <LabelForm>Hasta:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-3' margen_arriba='30'>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fechaEscogida)=>{this.setState({fechaHasta: fechaEscogida});}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm'  onClick={this.imprimirMvtosEfectivoPendDeposito}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}
  
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});
  
export default connect (null, mapDispatchToProps)(FormBanco08);